export default __webpack_public_path__ + "static/rope-34cea4b6bca394b7404c09009f7f17e4.png";